export class TrpTruckkArrival {
    public TA_LOC!: number;
    public TA_NO!: string;
    public TA_DATE!: string;
    public TA_VEHNO!: string;
    public TA_TRNTYPE!: string;
    public TA_VNO!: string;
    public TA_UID!: string;
    public TA_DRIVER1!: string;
    public TA_DRIVER2!: string;
    public TA_VENDOR!: number;
    public TA_3P!: string;
    public TA_DRIVER1_ID!: number;
    public TA_DRIVER2_ID!: number;
    public TA_MOBILENO!: string;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string;
    public UPDATED_DATE!: string;
    public IS_ACTIVE!: boolean;
}